module.exports = __webpack_public_path__ + "static/media/assista_quando_quiser.426832fa.png";